import React, { useState, useEffect } from 'react';
import EditableText from '../text/editable-text';
import { Flex } from '../layout/flex';
import ErrorText from '../text/error-text';

const titleMinLength = 3;

const SaveTierlistForm = ({
  isPublished,
  logEditorEvent,
  titleValidity,
  tierListTitle,
  tierListDescription,
  onTitleEditFinished,
  onDescriptionEditFinished,
  saving,
  saveFailed,
}) => {
  const [titleText, setTitleText] = useState(tierListTitle);
  const [descriptionText, setDescriptionText] = useState(tierListDescription);

  useEffect(() => {
    setTitleText(tierListTitle);
  }, [tierListTitle])

  useEffect(() => {
    setDescriptionText(tierListDescription);
  }, [tierListDescription])

  return (
    <div style={{padding: `10px 0`}}>
      <span>Title</span>
      <EditableText
        placeholder="Title"
        textAlign="left"
        textValue={titleText || ''}
        inputType="text"
        width="100%"
        onFocus={() => {
          logEditorEvent('title_edit_start', {
            description: titleText
          });
        }}
        onBlur={(e) => {
          onTitleEditFinished(titleText);
          logEditorEvent('title_edit_complete', {
            title: titleText
          });
        }}
        onInputChanged={(newValue) => {
          setTitleText(newValue);
        }}
      />
      <ErrorText
        errors={[
          {
            show: titleValidity.tooShort,
            message: `Title must be ${titleMinLength} characters or longer!`
          },
          {
            show: titleValidity.illegalCharacters,
            message: 'Sorry, only letters and numbers!'
          }
        ]}
      />
      <span>Description</span>
      <EditableText
        placeholder="Description"
        textValue={descriptionText || ''}
        textAlign="left"
        width="100%"
        inputType="textarea"
        rows={3}
        onFocus={() => {
          logEditorEvent('description_edit_start', {
            description: descriptionText
          });
        }}
        onBlur={() => {
          onDescriptionEditFinished(descriptionText);
          logEditorEvent('description_edit_complete', {
            description: descriptionText
          });
        }}
        onInputChanged={(newValue) => {
          setDescriptionText(newValue);
        }}
      />
      <Flex justifyContent="flex-end">
        <ErrorText
          errors={[
            {
              show: saveFailed,
              message: `Something went wrong... :(`
            }
          ]}
        />
      </Flex>
    </div>
  );
};

export default SaveTierlistForm;
